import * as React from 'react';
import { AnsweredQuestionDto } from '../../../../pages/answeredQuestionnaireTypes';
import { Table } from '@material-ui/core';
import { TableHead } from '@material-ui/core';
import { TableRow } from '@material-ui/core';
import { TableCell } from '@material-ui/core';
import { TableBody } from '@material-ui/core';
import { translation } from '../../../../i18n';
import MultilineText from '../../../MultilineText';

interface Props {
  answeredQuestion: AnsweredQuestionDto
  enableComment: boolean
}

class AnsweredTextQuestion extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  public render() {
    return (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{width: '20%'}}>{translation.t('answeredComponent.columnTitles.employee')}</TableCell>
                <TableCell>{translation.t('answeredComponent.columnTitles.answer')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                this.props.answeredQuestion.personalizedAnswers.map(answer => (
                  <TableRow key={this.props.answeredQuestion.id.toString() + answer.employee.id.toString()}>
                    <TableCell>{answer.employee.firstName + ' ' + answer.employee.lastName}</TableCell>
                    <TableCell><MultilineText text={answer.answer}/></TableCell>
                  </TableRow>
                ))
              }
              {
                this.renderCommentIfNeeded()
              }
            </TableBody>
          </Table>
    )
  }

  private renderCommentIfNeeded() {
    const comment = this.props.answeredQuestion.comment;
    if (!this.props.enableComment && comment != null) {
      return(
        <TableRow key={'comment'}>
          <TableCell>{translation.t('comment.comment')}</TableCell>
          <TableCell><MultilineText text={comment.comment}/></TableCell>
        </TableRow>
      )
    } else {
      return <></>
    }
  }
}

export default AnsweredTextQuestion;
